"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.knowledge.title': 'Open Knowledge Picker',
    'shortcuts.knowledge.description': 'Open the knowledge picker to search and select knowledge sources',
};
